import React from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import GuestPassReportTable from './GuestPassReportTable';
import { useTranslation } from 'react-i18next';

const GuestPassReprot: React.FC = () => {
    const { t } = useTranslation();
    return (
        <OpPage title={t('guestPassReport.title')} tooltip={t('guestPassReport.tooltip')}>
            <GuestPassReportTable />
        </OpPage>
    );
}

export default GuestPassReprot;
